// Learner rules of the authoring tool content that are not enforced when an admin previews the material.
// Each exception describes one rule: the rule's code checks isPreviewExceptionActive(key) in the view
// component to skip its enforcement, and the notice behind messageKey tells the admin about it.
// To add a new exception, add a key and an entry to PREVIEW_EXCEPTIONS.

export const PREVIEW_EXCEPTION_KEYS = Object.freeze({
    CHAPTER_NAVIGATION: 'chapterNavigation'
});

export function isLinearChapterNavigation (material) {
    return !!(material && material.settings && material.settings.chapterNavigation === 'linear');
}

const PREVIEW_EXCEPTIONS = [
    {
        key: PREVIEW_EXCEPTION_KEYS.CHAPTER_NAVIGATION,
        isApplicable: isLinearChapterNavigation,
        messageKey: 'authoringTool.Chapter navigation in sequence is disabled in preview'
    }
];

// Returns the exceptions for the rules the given material actually uses, so a notice is only shown
// for rules that would otherwise have been enforced.
export function getApplicablePreviewExceptions (material) {
    return PREVIEW_EXCEPTIONS
        .filter(exception => exception.isApplicable(material))
        .map(exception => ({ key: exception.key, messageKey: exception.messageKey }));
}



// WEBPACK FOOTER //
// ./src/app/services/authoringTool/previewExceptions.js